import { Link } from '@framework/router/Next/Link';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';
import TruncateText from '@creditflowresearch/uilib/TruncateText';

export const ParentCompany = ({ row: deal }: { row: IDealCellData }) => {
  const { parent, parentLink } = deal;
  return (
    parent.viewId && (
      <TruncateText value={ parent.name }>
        <Link to={ parentLink }>
          { parent.name }
        </Link>
      </TruncateText>
    )
  );
};
